import serviceEncuesta from '@/services/GsEncuesta/encuesta'

export default {
  ENCUESTA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_CLONE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.clone(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_FIND_LOGO(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.findLogo(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_FIND_BY_PROYECTO(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.findByProyecto(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_FIND_FICHA(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.findFicha(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ENCUESTA_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceEncuesta.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
